import { NgModule } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { SharedModule } from '../shared.module';
import { HeroSliderComponent } from './hero-slider.component';

@NgModule({
  imports: [SharedModule, SwiperModule],
  declarations: [HeroSliderComponent],
  exports: [HeroSliderComponent],
  providers: []
})
export class HeroSliderModule { }
